export default __webpack_public_path__ + "static/media/81t.692ac282.jpg";